import { firebaseDb } from '../firebase/'

export const loadNippoList = (startDate = null, endDate = null) => (
  dispatch => {
    const now = new Date()
    startDate = (startDate === null)? now : new Date(startDate)
    endDate = (endDate === null)? new Date(now.getFullYear(), now.getMonth(), now.getDate() - 1) : endDate = new Date(endDate)
    firebaseDb.collection('nippo').orderBy('createdAt', 'desc').startAt(startDate).endAt(endDate)
      .onSnapshot(snapshot => (
      dispatch({
        type: 'LOAD_NIPPO_LIST',
        snapshot
      })
    ), err => {
      console.log('Encountered error', err);
    })
  }
)

export const setFilteredNippo = (nippoList, selectedTeams, users) => ({
  type: 'SET_FILTERED_NIPPO',
  nippoList,
  selectedTeams,
  users
})

export const loadNextNippoList = (daysBefore) => (
  dispatch => {
    const startDate = new Date()
    startDate.setDate(startDate.getDate() - daysBefore)
    const endDate = new Date()
    endDate.setDate(endDate.getDate() - daysBefore - 1)

    firebaseDb.collection('nippo')
      .orderBy('createdAt', 'desc')
      .startAt(startDate).endAt(endDate)
      .get().then(docs =>(
      dispatch({
        type: 'LOAD_NEXT_NIPPO_LIST',
        docs
      })
    ), err => {
      console.log('Encountered an error', err)
    })
  }
)

export const loadNippo = (id) => (
  dispatch => {
    // TODO: Async
    firebaseDb.collection('nippo').doc(id).onSnapshot(snapshot => (
      dispatch({
        type: 'LOAD_NIPPO',
        snapshot
      })
    ), err => {
      console.log('Encountered error', err)
    })
    firebaseDb.collection('nippo').doc(id).collection('replies').onSnapshot(snapshot => (
      dispatch({
        type: 'LOAD_REPLY_LIST',
        snapshot
      })
    ), err => {
      console.log('Encountered error', err)
    })
  }
)

export const loadTrendList = () => (
  dispatch => {
    const date = new Date()
    date.setDate(date.getDate() - 1)

    firebaseDb.collection('nippo')
      .orderBy('score', 'desc')
      .orderBy('createdAt', 'desc')
      .startAt(date)
      .limit(3).get().then(docs =>(
      dispatch({
        type: 'LOAD_TREND_LIST',
        docs
      })
    ), err => {
      console.log('Encountered an error', err)
    })
  }
)

export const likeNippo = (nippoId, userId) => (
  dispatch => {
    firebaseDb.collection('nippo').doc(nippoId).get().then(doc => {
      let likesCount = doc.data().likesCount
      let likes = doc.data().likes
      let score = doc.data().score

      if (doc.data().likes.includes(userId)) {
        likesCount -= 1
        score -= 1
        const index = doc.data().likes.indexOf(userId)
        likes.splice(index, 1)
      } else {
        likesCount += 1
        score += 1
        likes = doc.data().likes.concat(userId)
      }
      firebaseDb.collection('nippo').doc(nippoId).update({
        likes: likes,
        likesCount: likesCount,
        score: score
      }).then(() => {
        //
      }, err => {
        console.log('Encountered error', err)
      })
    })
  }
)

export const changeSelectedTeam = (key, selectedTeams, nippoList, users) => (
  dispatch => {
    selectedTeams = selectedTeams.includes(key) ?
      selectedTeams.filter(value => value !== key) :
      selectedTeams.concat(key)
    dispatch(setFilteredNippo(nippoList, selectedTeams, users))
    dispatch({
      type: 'CHANGE_SELECTED_TEAM',
      selectedTeams
    })
  }
)

export const selectNippo = (value) => ({
  type: 'SELECT_NIPPO',
  selectedNippo: value
})
export const deselectNippo = () => ({
  type: 'DESELECT_NIPPO'
})



// WEBPACK FOOTER //
// ./src/actions/nippo.js